import { StyledActionButton } from "@/components/shared/StyledActionButton";
import { Center, Stack, Title } from "@mantine/core";
import { usePostHog } from "posthog-js/react";
import { NavLink } from "react-router-dom";

export function HomePage() {
  const posthog = usePostHog();
  return (
    <Stack style={{ height: "100%" }} pb="xl" align="center" justify="space-between">
      <div></div>
      <Center>
        <Title order={1} size="2.5rem" ta="center" style={{ wordBreak: "keep-all" }}>
          매주 수요일
          <br />
          취향으로 큐레이션 되는
          <br />
          다이닝 이벤트
        </Title>
      </Center>
      <Center />
      <StyledActionButton
        size="lg"
        component={NavLink}
        to="/event-reservation"
        onClick={() => posthog.capture("click_reserve_button")}
      >
        예약하기
      </StyledActionButton>
    </Stack>
  );
}
